<div class="smart-suggestions-panel" [class.compact]="compact" *ngIf="suggestions.length > 0">
  <!-- Cabeçalho -->
  <div class="suggestions-header">
    <div class="header-content">
      <nz-icon nzType="bulb" nzTheme="outline" class="suggestions-icon"></nz-icon>
      <span class="suggestions-title">{{ 'builderScreen.suggestions.title' |translateTA }}</span>
      <nz-badge [nzCount]="suggestions.length" nzSize="small"></nz-badge>
    </div>
    
    <div class="header-actions">
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        (click)="toggleSuggestions()"
        [nz-tooltip]="showSuggestions ? ('builderScreen.suggestions.hide' |translateTA) : ('builderScreen.suggestions.show' |translateTA)">
        <nz-icon [nzType]="showSuggestions ? 'eye-invisible' : 'eye'" nzTheme="outline"></nz-icon>
      </button>
      
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        (click)="dismissAllSuggestions()"
        [nz-tooltip]="'builderScreen.suggestions.dismissAll' |translateTA">
        <nz-icon nzType="close" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>

  <!-- Lista de Sugestões -->
  <div class="suggestions-list" *ngIf="showSuggestions">
    <div 
      *ngFor="let suggestion of suggestions; trackBy: trackBySuggestion"
      class="suggestion-item"
      [class.high-confidence]="suggestion.confidence >= 0.8"
      [class.medium-confidence]="suggestion.confidence >= 0.6 && suggestion.confidence < 0.8"
      [class.low-confidence]="suggestion.confidence < 0.6">
      
      <!-- Conteúdo da Sugestão -->
      <div class="suggestion-content">
        <div class="suggestion-main">
          <nz-icon 
            [nzType]="getSuggestionIcon(suggestion)" 
            nzTheme="outline"
            [style.color]="getConfidenceColor(suggestion.confidence)"
            class="suggestion-action-icon">
          </nz-icon>
          
          <div class="suggestion-text">
            <div class="suggestion-reason">{{ suggestion.reason |translateTA }}</div>
            <div class="suggestion-details">
              <nz-tag 
                [nzColor]="getConfidenceColor(suggestion.confidence)"
                nzSize="small">
                {{ getConfidenceText(suggestion.confidence) |translateTA }}
              </nz-tag>
              <span class="panel-name">{{ 'builderScreen.inspector.groups.' + suggestion.panelId + '.title' |translateTA }}</span>
            </div>
          </div>
        </div>
        
        <!-- Botões de Ação -->
        <div class="suggestion-actions">
          <button 
            nz-button 
            nzType="primary" 
            nzSize="small"
            (click)="applySuggestion(suggestion)"
            class="apply-btn">
            <nz-icon nzType="check" nzTheme="outline"></nz-icon>
            <span *ngIf="!compact">{{ 'builderScreen.suggestions.apply' |translateTA }}</span>
          </button>
          
          <button 
            nz-button 
            nzType="text" 
            nzSize="small"
            (click)="dismissSuggestion(suggestion)"
            class="dismiss-btn">
            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
          </button>
        </div>
      </div>
      
      <!-- Indicador de Confiança -->
      <div class="confidence-indicator">
        <div 
          class="confidence-bar"
          [style.width.%]="suggestion.confidence * 100"
          [style.background-color]="getConfidenceColor(suggestion.confidence)">
        </div>
      </div>
    </div>
  </div>

  <!-- Estado Vazio -->
  <div class="suggestions-empty" *ngIf="showSuggestions && suggestions.length === 0">
    <nz-empty 
      nzNotFoundImage="simple"
      [nzNotFoundContent]="'builderScreen.suggestions.noSuggestions' |translateTA">
    </nz-empty>
  </div>
</div>
